import dayjs from "dayjs";
import { OrdersAPI } from "@api-clients/orders";
import { OrdersState } from "libs/orders-state/src";
import { ISubscriptionOverview } from "@api-clients/subscriptions";
import { CatsAPI, SubscriptionFilter } from "@api-clients/cats";

import { Allergen } from "@/primary-models";

const DECEMBER_INDEX = 11;

export async function checkXmasRecipeEligibility(
  catsAPI: CatsAPI,
  ordersAPI: OrdersAPI,
  subscriptionId: number,
  subscriptionsOverview: ISubscriptionOverview,
): Promise<boolean> {
  if (!catsAPI) {
    return false;
  }
  const ALLERGENS: Set<Allergen> = new Set([
    Allergen.CHICKEN,
    Allergen.DUCK,
    Allergen.TURKEY,
  ]);

  const ordersState = new OrdersState(ordersAPI);

  const sub = subscriptionsOverview.freshMealPlans.find((plan) => plan.id === subscriptionId);

  if (dayjs(sub?.date?.nextDelivery).month() !== DECEMBER_INDEX) {
    return false;
  }

  // Check if the user is allergic to chicken or salmon
  const { cats } = await catsAPI.getCats({
    filterSubscription: SubscriptionFilter.HAS_FRESH,
    showSuppressedCats: false,
  });
  const thisCat = cats.find((c) => c.subscription?.subscriptionId === subscriptionId);

  if (thisCat) {
    const allergicToRecipe = thisCat.details.allergies?.some((allergy) => ALLERGENS.has(allergy));
    if (allergicToRecipe) {
      return false;
    }
    const hasAlreadyHadRecipe = await ordersState.hadXmasRecipe(subscriptionId);
    return !hasAlreadyHadRecipe;
  }

  // Fallback to assume they won't receive it
  return false;
}
